module.exports = __webpack_public_path__ + "static/img/jdy3.cbc7f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jdy3.png
// module id = d14S
// module chunks = 0